(() => {
  const qs = (s, c=document) => c.querySelector(s);
  const qsa = (s, c=document) => [...c.querySelectorAll(s)];
  const body = document.body;
  let lastTrigger = null;
  let snackRecognition = null;
  let snackVoiceButton = null;
  let snackSearchAbort = null;

  const announce = (message) => {
    const region = qs('[data-live-region]');
    if (!region) return;
    region.textContent = '';
    requestAnimationFrame(() => { region.textContent = message; });
  };

  const focusables = (root) => qsa('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', root).filter(el => !el.hidden && el.offsetParent !== null);

  const trapFocus = (event, root) => {
    if (event.key !== 'Tab' || !root) return;
    const items = focusables(root);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  };

  const money = (cents) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency', currency:(window.Shark?.currency || 'EUR')}).format((Number(cents)||0)/100); }
    catch(e) { return `${((Number(cents)||0)/100).toFixed(2)} €`; }
  };

  const syncBodyLock = () => {
    const overlayOpen = Boolean(
      qs('[data-cart-drawer-shell].is-open') ||
      qs('[data-search-drawer]:not([hidden])') ||
      qs('[data-mobile-menu]:not([hidden])') ||
      qs('[data-snack-finder-shell].is-open') ||
      qs('[data-mix-added-modal]')
    );
    body.classList.toggle('no-scroll', overlayOpen);
  };

  const closeMobileMenu = (restoreFocus=false) => {
    const menu=qs('[data-mobile-menu]');
    if(!menu)return;
    menu.hidden=true;
    menu.setAttribute('aria-hidden','true');
    body.classList.remove('mobile-menu-open');
    qsa('[data-mobile-menu-open]').forEach(button=>button.setAttribute('aria-expanded','false'));
    syncBodyLock();
    if(restoreFocus)lastTrigger?.focus?.();
  };

  const stopSnackVoice = () => {
    if(snackRecognition){
      try{snackRecognition.abort();}catch(error){}
    }
    snackRecognition=null;
    if(snackVoiceButton){
      snackVoiceButton.textContent='🎙️';
      snackVoiceButton.removeAttribute('aria-busy');
      snackVoiceButton.setAttribute('aria-pressed','false');
      snackVoiceButton.classList.remove('is-listening');
    }
    snackVoiceButton=null;
  };

  const openCart = () => { const s=qs('[data-cart-drawer-shell]'); if(s){s.classList.add('is-open');syncBodyLock();const drawer=qs('[data-cart-drawer]',s);drawer?.focus();announce('Warenkorb geöffnet');} };
  const closeCart = () => { const s=qs('[data-cart-drawer-shell]'); if(s){s.classList.remove('is-open');syncBodyLock();lastTrigger?.focus?.();announce('Warenkorb geschlossen');} };
  const openSnackFinder = (trigger) => {
    const shell=qs('[data-snack-finder-shell]');
    if(!shell)return;
    lastTrigger=trigger||document.activeElement;
    closeMobileMenu(false);
    shell.classList.add('is-open');
    shell.setAttribute('aria-hidden','false');
    syncBodyLock();
    setTimeout(()=>qs('[data-snack-finder-input]',shell)?.focus(),80);
    announce('Snack-Berater geöffnet');
  };
  const closeSnackFinder = () => {
    const shell=qs('[data-snack-finder-shell]');
    if(!shell)return;
    stopSnackVoice();
    if(snackSearchAbort)snackSearchAbort.abort();
    shell.classList.remove('is-open');
    shell.setAttribute('aria-hidden','true');
    syncBodyLock();
    lastTrigger?.focus?.();
    announce('Snack-Berater geschlossen');
  };

  document.addEventListener('click', e => {
    if(e.target.closest('[data-cart-open]')) { e.preventDefault(); lastTrigger=e.target.closest('[data-cart-open]'); openCart(); }
    if(e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); }
    if(e.target.closest('[data-search-open]')) { lastTrigger=e.target.closest('[data-search-open]'); const d=qs('[data-search-drawer]'); if(d){d.hidden=false; syncBodyLock(); setTimeout(()=>qs('[data-predictive-search-input]',d)?.focus(),30);} }
    if(e.target.closest('[data-search-close]')) { const d=qs('[data-search-drawer]'); if(d)d.hidden=true; syncBodyLock(); lastTrigger?.focus?.(); }
    if(e.target.closest('[data-mobile-menu-open]')) {
      e.preventDefault();
      lastTrigger=e.target.closest('[data-mobile-menu-open]');
      const m=qs('[data-mobile-menu]');
      if(m){
        m.hidden=false;
        m.setAttribute('aria-hidden','false');
        body.classList.add('mobile-menu-open');
        qsa('[data-mobile-menu-open]').forEach(button=>button.setAttribute('aria-expanded','true'));
        syncBodyLock();
        setTimeout(()=>focusables(m)[0]?.focus(),30);
      }
    }
    if(e.target.closest('[data-mobile-menu-close]')) { e.preventDefault(); closeMobileMenu(true); }
    if(e.target.closest('[data-snack-finder-open]')) { e.preventDefault(); openSnackFinder(e.target.closest('[data-snack-finder-open]')); }
    if(e.target.closest('[data-snack-finder-close]')) { e.preventDefault(); closeSnackFinder(); }
    const snackChip=e.target.closest('[data-snack-query]');
    if(snackChip){ const input=qs('[data-snack-finder-input]'); if(input){input.value=snackChip.dataset.snackQuery; qs('[data-snack-finder-form]')?.requestSubmit();} }
    if(e.target.closest('[data-snack-finder-voice]')) { e.preventDefault(); startSnackVoice(e.target.closest('[data-snack-finder-voice]')); }
    if(e.target.closest('[data-cookie-preferences]')) {
      if(window.privacyBanner?.showPreferences){e.preventDefault();window.privacyBanner.showPreferences();}
    }
    const withdrawalReview=e.target.closest('[data-withdrawal-review]');
    if(withdrawalReview){
      e.preventDefault();
      const form=withdrawalReview.closest('form');
      if(!form?.reportValidity())return;
      const fields=qs('[data-withdrawal-fields]',form),confirmation=qs('[data-withdrawal-confirmation]',form),summary=qs('[data-withdrawal-summary]',form);
      if(summary){
        summary.innerHTML='';
        [['Name','#WithdrawalName'],['E-Mail','#WithdrawalEmail'],['Bestellnummer','#WithdrawalOrder'],['Umfang','#WithdrawalScope'],['Hinweis','#WithdrawalDetails']].forEach(([label,selector])=>{
          const value=qs(selector,form)?.value?.trim();if(!value)return;
          const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value;summary.append(dt,dd);
        });
      }
      if(fields)fields.hidden=true;if(confirmation){confirmation.hidden=false;confirmation.focus?.();confirmation.scrollIntoView({behavior:'smooth',block:'start'});}
    }
    const withdrawalEdit=e.target.closest('[data-withdrawal-edit]');
    if(withdrawalEdit){
      e.preventDefault();
      const form=withdrawalEdit.closest('form'),fields=qs('[data-withdrawal-fields]',form),confirmation=qs('[data-withdrawal-confirmation]',form);
      if(confirmation)confirmation.hidden=true;if(fields){fields.hidden=false;qs('input',fields)?.focus();}
    }
    if(e.target.closest('[data-filter-open]')) qs('[data-filter-panel]')?.classList.add('is-open');
    if(e.target.closest('[data-filter-close]')) qs('[data-filter-panel]')?.classList.remove('is-open');
    const minus=e.target.closest('[data-qty-minus]'), plus=e.target.closest('[data-qty-plus]');
    if(minus||plus){const wrap=e.target.closest('.quantity');const input=qs('input',wrap);if(input){const n=Math.max(1,(parseInt(input.value)||1)+(plus?1:-1));input.value=n;}}
    const cartQty=e.target.closest('[data-cart-qty]');
    if(cartQty){ const line=e.target.closest('[data-cart-line]'); if(line) changeCart(line.dataset.key, Number(cartQty.dataset.cartQty)); }
    const cartRemove=e.target.closest('[data-cart-remove]');
    if(cartRemove){ const line=cartRemove.closest('[data-cart-line]'); if(line) changeCart(line.dataset.key,0,cartRemove.hasAttribute('data-cart-page-action')); }
    const cartClear=e.target.closest('[data-cart-clear]');
    if(cartClear){ clearCart(cartClear.hasAttribute('data-cart-page-action')); }
    const mixAddedClose=e.target.closest('[data-mix-added-close]');
    if(mixAddedClose){e.preventDefault();qs('[data-mix-added-modal]')?.remove();syncBodyLock();}
    if(e.target.closest('[data-submit-main-product]')) qs('[data-main-product] form[data-ajax-cart] button[type="submit"]')?.click();
  });

  const refreshCart = async (refreshPage=false) => {
    const sections = refreshPage ? 'cart-drawer,main-cart' : 'cart-drawer';
    const url = `${window.Shark.routes.cart}?sections=${sections}`;
    const res = await fetch(url, {headers:{'X-Requested-With':'XMLHttpRequest'}});
    const data = await res.json();
    const html = data['cart-drawer'];
    if(html){
      const doc = new DOMParser().parseFromString(html,'text/html');
      const next = qs('[data-cart-drawer-shell]',doc);
      const current = qs('[data-cart-drawer-shell]');
      if(next&&current){ current.replaceWith(next); loadCartUpsells(next); }
    }
    if(refreshPage && data['main-cart']){
      const doc = new DOMParser().parseFromString(data['main-cart'],'text/html');
      const next = qs('[data-cart-page-section]',doc);
      const current = qs('[data-cart-page-section]');
      if(next&&current) current.replaceWith(next);
    }
    const cartRes = await fetch(`${window.Shark.routes.cart}.js`);
    const cart = await cartRes.json();
    qsa('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    return cart;
  };

  const changeCart = async (id, quantity, reloadPage=false) => {
    body.classList.add('is-loading');
    try {
      const response = await fetch(window.Shark.routes.cartChange, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id,quantity})});
      if(!response.ok) throw new Error('Menge konnte nicht aktualisiert werden.');
      await refreshCart(reloadPage);
      if(reloadPage) announce(quantity===0?'Produkt entfernt':'Warenkorb aktualisiert');
      else { openCart(); announce(quantity===0?'Produkt entfernt':'Warenkorb aktualisiert'); }
    } catch(error) { announce(error.message); }
    finally { body.classList.remove('is-loading'); }
  };

  const clearCart = async (reloadPage=false) => {
    if(!window.confirm('Möchtest du den Warenkorb wirklich komplett leeren?')) return;
    body.classList.add('is-loading');
    try {
      const response=await fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'}});
      if(!response.ok) throw new Error('Warenkorb konnte nicht geleert werden.');
      await refreshCart(reloadPage);
      if(reloadPage) announce('Warenkorb wurde geleert');
      else { openCart(); announce('Warenkorb wurde geleert'); }
    } catch(error) { announce(error.message); }
    finally { body.classList.remove('is-loading'); }
  };

  document.addEventListener('snackshark:cart-updated', async () => {
    await refreshCart();
    openCart();
    announce('Artikel wurde zum Warenkorb hinzugefügt');
  });

  const showMixAddedModal = () => {
    const params=new URLSearchParams(location.search);
    if(params.get('mix_added')!=='1')return;
    params.delete('mix_added');
    const clean=`${location.pathname}${params.toString()?`?${params}`:''}${location.hash}`;
    history.replaceState({},'',clean);
    let savedMix=null;
    try{savedMix=JSON.parse(sessionStorage.getItem('snacksharkLastMix')||'null');}catch(error){}
    const resumeQuery=new URLSearchParams({resume_mix:'1'});
    if(params.get('preview_theme_id'))resumeQuery.set('preview_theme_id',params.get('preview_theme_id'));
    const resumePath=savedMix?.path&&String(savedMix.path).startsWith('/pages/')?`${savedMix.path}?${resumeQuery}`:'';
    const modal=document.createElement('div');
    modal.className='mix-added-modal';modal.dataset.mixAddedModal='';
    modal.innerHTML=`<button class="mix-added-modal__backdrop" type="button" data-mix-added-close aria-label="Hinweis schließen"></button><section class="mix-added-modal__card" role="dialog" aria-modal="true" aria-labelledby="MixAddedTitle"><button class="mix-added-modal__close" type="button" data-mix-added-close aria-label="Schließen">×</button><div class="mix-added-modal__icon">🎉</div><p class="eyebrow">Dein Mix ist sicher</p><h2 id="MixAddedTitle">Ab in den Warenkorb.</h2><p>Dein individueller Mix wurde übernommen. Du kannst weiterstöbern, einen neuen Mix starten oder deine Auswahl kopieren und verändern.</p><div class="mix-added-modal__actions">${resumePath?`<a class="button button--primary" href="${resumePath}">Mix übernehmen & ändern</a>`:''}<a class="button button--secondary" href="/pages/pick-and-mix-candy-snack-muesli-konfigurator">Komplett neuen Mix bauen</a><button class="button button--ghost" type="button" data-cart-open data-mix-added-close>Warenkorb ansehen</button><button class="button button--ghost" type="button" data-mix-added-close>Weiter shoppen</button></div></section>`;
    body.append(modal);syncBodyLock();setTimeout(()=>qs('.mix-added-modal__close',modal)?.focus(),30);
  };
  showMixAddedModal();

  document.addEventListener('submit', async e => {
    const snackForm=e.target.closest('[data-snack-finder-form]');
    if(snackForm){e.preventDefault();findSnacks(qs('[data-snack-finder-input]',snackForm)?.value||'');return;}
    const bundleForm=e.target.closest('[data-bundle-form]');
    if(bundleForm){
      e.preventDefault();
      const selected=qsa('input[name="bundle_item"]:checked',bundleForm);
      const button=qs('[data-bundle-submit]',bundleForm);
      if(!selected.length){announce('Bitte wähle mindestens ein Produkt aus.');return;}
      const old=button?.textContent;if(button){button.disabled=true;button.textContent='Auswahl wird hinzugefügt …';}
      try{
        const response=await fetch(window.Shark.routes.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:selected.map(input=>({id:Number(input.value),quantity:1}))})});
        if(!response.ok) throw new Error((await response.json()).description||'Bundle konnte nicht hinzugefügt werden.');
        await refreshCart();openCart();announce(`${selected.length} Produkte wurden hinzugefügt`);
      }catch(error){announce(error.message);const box=document.createElement('div');box.className='form-inline-error';box.setAttribute('role','alert');box.textContent=error.message;bundleForm.append(box);}
      finally{if(button){button.disabled=false;button.textContent=old;}}
      return;
    }
    const form=e.target.closest('form[data-ajax-cart]'); if(!form) return;
    e.preventDefault();
    const btn=qs('button[type="submit"]',form); const old=btn?.innerHTML; const compactAdd=btn?.classList.contains('mini-add');
    if(btn){btn.disabled=true;btn.classList.toggle('is-loading',Boolean(compactAdd));btn.innerHTML=compactAdd?'…':'Wird hinzugefügt …';}
    qs('.form-inline-error',form)?.remove();
    try{
      const fd=new FormData(form);
      const res=await fetch(window.Shark.routes.cartAdd,{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:fd});
      if(!res.ok) throw new Error((await res.json()).description||'Konnte nicht hinzugefügt werden');
      await refreshCart(); openCart(); announce('Artikel wurde zum Warenkorb hinzugefügt');
    }catch(err){const error=document.createElement('div');error.className='form-inline-error';error.setAttribute('role','alert');error.textContent=err.message||'Bitte versuche es erneut.';form.append(error);announce(error.textContent);}
    finally{if(btn){btn.disabled=false;btn.classList.remove('is-loading');btn.innerHTML=old;}}
  });

  // Predictive search
  let searchTimer, searchAbort;
  document.addEventListener('input', e => {
    const input=e.target.closest('[data-predictive-search-input]'); if(!input) return;
    clearTimeout(searchTimer); if(searchAbort) searchAbort.abort();
    const target=qs('[data-predictive-search-results]'); const term=input.value.trim();
    if(term.length<2){if(target)target.innerHTML='';return;}
    searchTimer=setTimeout(async()=>{
      searchAbort=new AbortController();
      const root=window.Shopify?.routes?.root || '/';
      const url=`${root}search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,collection&resources[limit]=8&section_id=predictive-search`;
      try{const res=await fetch(url,{signal:searchAbort.signal});const text=await res.text();const doc=new DOMParser().parseFromString(text,'text/html');if(target)target.innerHTML=qs('.shopify-section',doc)?.innerHTML || text;}catch(err){if(err.name!=='AbortError')console.warn(err);}
    },180);
  });

  const findSnacks = async (query) => {
    const target=qs('[data-snack-finder-results]'); query=query.trim();
    if(!target||query.length<2){if(target)target.innerHTML='<p class="snack-finder__status">Bitte gib mindestens zwei Zeichen ein.</p>';return;}
    if(snackSearchAbort)snackSearchAbort.abort();
    const controller=new AbortController();
    snackSearchAbort=controller;
    target.innerHTML='<p class="snack-finder__status">Wir tauchen kurz ins Snack-Regal …</p>';
    try{
      const root=window.Shopify?.routes?.root||'/';
      const normalized=query.toLowerCase();
      const searchTerm=normalized.includes('japan')?'Japan':normalized.includes('geburtstag')||normalized.includes('party')?'Geschenk':normalized.includes('monster')||normalized.includes('energy')?'Monster':normalized.includes('wunscht')||normalized.includes('misch')?'Wunschtüte':normalized.includes('sauer')?'sauer':query;
      const url=`${root}search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product,collection,article&resources[limit]=8`;
      const timeout=setTimeout(()=>controller.abort(),8000);
      const res=await fetch(url,{headers:{Accept:'application/json'},signal:controller.signal});clearTimeout(timeout);if(!res.ok)throw new Error('Suche nicht erreichbar');
      const results=(await res.json())?.resources?.results||{}; const products=results.products||[], collections=results.collections||[], articles=results.articles||[];
      const cards=products.map(item=>`<a class="snack-finder__result" href="${item.url}">${item.image?`<img src="${item.image}" alt="" loading="lazy">`:'<span></span>'}<span><strong>${escapeHtml(item.title)}</strong><small>${item.price||'Produkt ansehen'} →</small></span></a>`).join('');
      const links=[...collections,...articles].map(item=>`<a class="snack-finder__chip" href="${item.url}">${escapeHtml(item.title)} →</a>`).join('');
      target.innerHTML=(cards?`<p class="eyebrow">Unsere Treffer</p><div class="snack-finder__grid">${cards}</div>`:'')+(links?`<p class="eyebrow" style="margin-top:20px">Snack-Welten & Ratgeber</p><div class="snack-finder__chips">${links}</div>`:'')||'<p class="snack-finder__status">Noch kein perfekter Treffer. Versuch es mit Produktart, Land oder Geschmack.</p>';
    }catch(error){if(error.name!=='AbortError')target.innerHTML='<p class="snack-finder__status">Die Suche hatte gerade Schluckauf. Nutze bitte kurz die normale Shop-Suche.</p>';}
    finally{if(snackSearchAbort===controller)snackSearchAbort=null;}
  };
  const escapeHtml = value => String(value||'').replace(/[&<>'"]/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const startSnackVoice = button => {
    const Recognition=window.SpeechRecognition||window.webkitSpeechRecognition;
    const target=qs('[data-snack-finder-results]');
    if(snackRecognition){stopSnackVoice();if(target)target.innerHTML='<p class="snack-finder__status">Spracheingabe beendet. Du kannst direkt weitertippen.</p>';return;}
    if(!Recognition){
      const message='Dieser Browser unterstützt die Spracheingabe leider nicht. Die Textsuche funktioniert weiterhin.';
      announce(message);button.title='Spracheingabe hier nicht verfügbar';if(target)target.innerHTML=`<p class="snack-finder__status">${message}</p>`;return;
    }
    try{
      const recognition=new Recognition();
      snackRecognition=recognition;snackVoiceButton=button;
      recognition.lang=(document.documentElement.lang||'de-DE').startsWith('de')?'de-DE':document.documentElement.lang;
      recognition.interimResults=false;recognition.continuous=false;recognition.maxAlternatives=1;
      button.textContent='●';button.setAttribute('aria-busy','true');button.setAttribute('aria-pressed','true');button.classList.add('is-listening');
      if(target)target.innerHTML='<p class="snack-finder__status snack-finder__status--listening">Ich höre zu … Sprich jetzt deinen Wunsch.</p>';
      recognition.onresult=event=>{
        const transcript=event.results?.[0]?.[0]?.transcript?.trim();
        const input=qs('[data-snack-finder-input]');
        if(input&&transcript){input.value=transcript;announce(`Erkannt: ${transcript}`);qs('[data-snack-finder-form]')?.requestSubmit();}
      };
      recognition.onerror=event=>{
        const messages={
          'not-allowed':'Bitte erlaube den Mikrofonzugriff im Browser – oder nutze direkt die Textsuche.',
          'service-not-allowed':'Die Spracheingabe ist in diesem Browser blockiert. Die Textsuche bleibt verfügbar.',
          'audio-capture':'Es wurde kein verfügbares Mikrofon gefunden. Die Textsuche bleibt verfügbar.',
          'no-speech':'Ich habe nichts gehört. Tippe deinen Wunsch ein oder versuche es erneut.',
          'network':'Die Spracherkennung ist gerade nicht erreichbar. Die Textsuche bleibt verfügbar.'
        };
        const message=messages[event.error]||'Sprache konnte gerade nicht erkannt werden. Die Textsuche bleibt verfügbar.';
        announce(message);if(target)target.innerHTML=`<p class="snack-finder__status">${message}</p>`;
      };
      recognition.onend=()=>stopSnackVoice();
      recognition.start();
    }catch(error){
      stopSnackVoice();
      const message='Die Spracheingabe konnte nicht gestartet werden. Die Textsuche bleibt verfügbar.';
      announce(message);if(target)target.innerHTML=`<p class="snack-finder__status">${message}</p>`;
    }
  };

  // Variant select: update URL + visible price + button state where possible.
  document.addEventListener('change', e => {
    const select=e.target.closest('[data-variant-select]'); if(!select) return;
    const opt=select.selectedOptions[0];
    const root=e.target.closest('[data-main-product]');
    if(!root) return;
    history.replaceState({},'',`${location.pathname}?variant=${select.value}`);
    const price=qs('.product-block--price .price__current',root); if(price&&opt.dataset.price) price.textContent=money(opt.dataset.price);
    const sticky=qs('[data-sticky-price]',root); if(sticky&&opt.dataset.price) sticky.textContent=money(opt.dataset.price);
    const sku=qs('[data-product-sku]',root); if(sku) sku.textContent=`SKU: ${opt.dataset.sku || '–'}`;
    const submit=qs('form[data-ajax-cart] button[type="submit"]',root); if(submit){const available=opt.dataset.available==='true'; submit.disabled=!available; const label=qs('[data-atc-label]',submit); if(label) label.textContent=available?'In den Warenkorb':'Ausverkauft';}
    const stickyBtn=qs('[data-submit-main-product]',root); if(stickyBtn) stickyBtn.disabled=opt.dataset.available!=='true';
  });

  // Recommendations sections (if empty initially)
  qsa('[data-recommendations][data-url]').forEach(async el=>{
    if(el.innerHTML.trim()) return;
    try{const res=await fetch(el.dataset.url);const text=await res.text();const doc=new DOMParser().parseFromString(text,'text/html');const next=qs('[data-recommendations]',doc);if(next?.innerHTML.trim())el.innerHTML=next.innerHTML;}catch(e){}
  });

  const loadCartUpsells = async (root=document) => {
    const target=qs('[data-cart-upsell-target]',root); if(!target||!target.dataset.url||target.dataset.loaded==='true')return;
    target.dataset.loaded='true';
    try{
      const fetchFragment=async url=>{const res=await fetch(url,{headers:{'X-Requested-With':'XMLHttpRequest'}});const html=await res.text();const doc=new DOMParser().parseFromString(html,'text/html');return qs('[data-cart-upsell-fragment]',doc);};
      let fragment=await fetchFragment(target.dataset.url);
      if(!fragment?.innerHTML.trim()&&target.dataset.url.includes('intent=complementary')) fragment=await fetchFragment(target.dataset.url.replace('intent=complementary','intent=related'));
      target.innerHTML=fragment?.innerHTML.trim()?fragment.innerHTML:'<p class="snack-finder__status">Entdecke noch mehr in unseren Bestseller-Welten.</p>';
    }catch(error){target.innerHTML='<p class="snack-finder__status">Empfehlungen sind gleich wieder da.</p>';}
  };
  loadCartUpsells();

  document.addEventListener('change', e=>{ const select=e.target.closest('[data-localization-select]'); if(select) select.form?.submit(); });

  const updateBundle = (form) => {
    const selected=qsa('input[name="bundle_item"]:checked',form);
    const total=selected.reduce((sum,input)=>sum+Number(input.dataset.price||0),0);
    const count=qs('[data-bundle-count]',form),totalEl=qs('[data-bundle-total]',form),submit=qs('[data-bundle-submit]',form);
    if(count) count.textContent=`${selected.length} ${selected.length===1?'Produkt':'Produkte'}`;
    if(totalEl) totalEl.textContent=money(total);
    if(submit) submit.disabled=selected.length===0;
  };
  qsa('[data-bundle-form]').forEach(updateBundle);
  document.addEventListener('change',e=>{const item=e.target.closest('input[name="bundle_item"]');if(item)updateBundle(item.form);});

  document.addEventListener('keydown', e=>{
    const cart=qs('[data-cart-drawer-shell].is-open [data-cart-drawer]');
    const search=qs('[data-search-drawer]:not([hidden])');
    const menu=qs('[data-mobile-menu]:not([hidden])');
    const snackFinder=qs('[data-snack-finder-shell].is-open [data-snack-finder]');
    trapFocus(e,cart||search||menu||snackFinder);
    if(e.key==='Escape'){closeCart();closeSnackFinder();if(search)search.hidden=true;if(menu)closeMobileMenu(false);syncBodyLock();lastTrigger?.focus?.();}
  });
})();
